import { component as defineComponent } from 'flightjs';

function DropdownRepositioner() {
    this.defaultAttrs({
        eventName: null,
        dropdowns: null,
    });

    this.after('initialize', function () {
        this.on(document, this.attr.eventName, this.repositionDetachedDropdown);
    });

    this.repositionDetachedDropdown = function () {
        const dropdowns = this.attr.dropdowns;
        const clickTarget = this.$node[0];

        dropdowns.forEach((dropdown) => {
            if (dropdown.$el[0].contains(clickTarget)) {
                dropdown.positionDropdown();
            }
        });
    };
}

export default defineComponent(DropdownRepositioner);



// WEBPACK FOOTER //
// ./src/js/component_ui/dropdown-repositioner.js